const UNKNOWN_REGION_PLACEHOLDER = "Outside Forecast Region";

const getters = {
  regionById(state) {
    return id => state.regions.find(region => region.id === id);
  },

  regionByName(state) {
    return name => state.regions.find(region => region.title === name);
  },

  regionTitleById(state, getters) {
    return id => (id ? getters.regionById(id).title : "–");
  },

  forecastByRegion(state) {
    return id => state.forecasts.find(forecast => parseInt(forecast.regionId, 10) === id);
  },

  regionDangerRating(state) {
    return id => {
      const forecast = state.forecasts.find(f => parseInt(f.regionId, 10) === id);
      let highestLevel = { rating: 0 };

      if (forecast) {
        forecast.altitudeDanger.forEach(function(danger) {
          if (parseInt(danger.rating, 10) > highestLevel.rating) {
            highestLevel = danger;
          }
        });
      }

      return highestLevel;
    };
  },

  allObservationsGeoJson(state, getters) {
    return () => ({
      type: "FeatureCollection",
      features: getters.filteredObservations.map(o => formatObservationFeature(o, state.selectedObservation.id))
    });
  },

  recentObservationsGeoJson(state, getters) {
    return () => ({
      type: "FeatureCollection",
      features: getters.filteredObservations
        .filter(o => o.is_recent)
        .map(o => formatObservationFeature(o, state.selectedObservation.id))
    });
  },

  filteredObservationsGeoJson(state, getters) {
    return () => ({
      type: "FeatureCollection",
      features: getters.filteredObservations.map(o => formatObservationFeature(o, state.selectedObservation.id))
    });
  },

  observationById(state) {
    return id => state.observations.find(observation => observation.id === id);
  },

  filteredObservations(state, getters) {
    let observations = state.observations;

    if (state.observationsFilters.regions && state.observationsFilters.regions.length) {
      const regionIDs = state.observationsFilters.regions.map(o => o.value);

      const unknownRegion = getters.regionByName(UNKNOWN_REGION_PLACEHOLDER);
      if (unknownRegion && regionIDs.includes(unknownRegion.id)) {
        regionIDs.push(0);
      }
      
      observations = observations.filter(o => regionIDs.includes(o.region_id));
    }

    if (state.observationsFilters.type) {
      observations = observations.filter(o => o.type === state.observationsFilters.type.value);
    }

    if (state.observationsFilters.dateFrom) {
      const dateTimeFrom = `${state.observationsFilters.dateFrom} 00:00:00`;
      const dateTimeTo = state.observationsFilters.dateTo ? `${state.observationsFilters.dateTo} 23:59:59` : null;
      observations = observations.filter(o => o.time >= dateTimeFrom && (!dateTimeTo || o.time <= dateTimeTo));
    }

    if (state.observationsFilters.sort) {
      const sorts = {
        time: (a, b) => b.time.localeCompare(a.time),
        region: (a, b) => getters.regionTitleById(a.region_id).localeCompare(getters.regionTitleById(b.region_id)),
        triggerType: (a, b) => (a.triggerType || "").localeCompare(b.triggerType || "")
      };

      observations = observations.sort(sorts[state.observationsFilters.sort.value]);
    }

    return observations;
  }
};

export default getters;

const formatObservationFeature = (observation, selectedID) => ({
  type: "Feature",
  properties: {
    id: observation.id,
    is_recent: observation.is_recent,
    type: observation.type,
    selected: observation.id === selectedID
  },
  geometry: {
    type: "Point",
    coordinates: [observation.coordinates.lng, observation.coordinates.lat]
  }
});
